import type { EventParams } from '@yandex-int/k-common';

interface WebinarEventBaseCert2025Props extends EventParams {
    slug: 'webinar' | 'event';
}

/** Серт для вебинара или события для 2025 года */
export const WebinarEventBaseCert2025 = ({
    school_name: schoolName,
    locality,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    event_duration: eventDuration,
    event_date: eventDate,
    event_description: eventDescription,
    event_region: eventRegion,
    slug,
}: WebinarEventBaseCert2025Props) => {
    let title;
    let image;
    const schoolNameMessage = `получает педагог <br/> ${schoolName ? `${schoolName}` : ''}, </br> ${locality}`;
    switch (slug) {
        case 'webinar': {
            title = 'Сертификат за участие в вебинарах';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/0c3Pi9Uwf8kb9NTDFqY5m/orig';
            break;
        }
        case 'event': {
            title = 'Сертификат за событие';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5577852/b5XgRlqXyV0Lk2pY1xmYr/orig';
            break;
        }
    }
    return `<!DOCTYPE html>
    <html lang="ru">
        <head>
            <title>${title}</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style>
                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
                    font-weight: 300;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                    font-weight: 400;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                    font-weight: 500;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
                    font-weight: bold;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: bold;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: 800;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
                }

                @page {
                    size: 210mm 297mm;
                    margin: 0;
                    padding: 0;
                }

                @media print {
                    html,
                    body {
                        width: 210mm;
                        height: 297mm;

                        box-sizing: border-box;
                    }
                }

                html {
                    position: relative;

                    margin: 0;
                    padding: 0;
                    --text-color: rgba(0, 0, 0, 0.9);
                    --secondary-text-color: rgba(0, 0, 0, 0.6);

                }

                body {
                    margin: 0;

                    color: var(--text-color);

                    font-family: 'YS Text', sans-serif;
                }

                .page {
                    position: relative;

                    overflow: hidden;

                    box-sizing: border-box;

                    width: 210mm;
                    height: 297mm;

                    background: var(--background-color);

                    page-break-after: always;
                }

                .page__background {
                    position: absolute;

                    width: 100%;
                    height: 100%;

                    overflow: hidden;

                    display: flex;

                    z-index: 1;
                }

                .page__content {
                    height: 100%;
                    width: 100%;
                }

                .content {
                    position: relative;
                    box-sizing: border-box;

                    display: flex;

                    z-index: 5;
                    flex-direction: column;

                    width: calc(210 / 595 * 369mm);

                    padding-left: calc(210 / 595 * 24mm);
                    padding-bottom: calc(210 / 595 * 24mm);

                    color: var(--text-color);
                }

                .empty-space {
                    height: 46.5%
                }

                .content_title {
                    font-size: calc(297 / 842 * 48mm);
                    font-weight: 400;
                    line-height: calc(297 / 842 * 52mm);
                }


                .personal-info__school {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12pt;
                    line-height: 16.8pt;
                    color: var(--secondary-text-color);
                    margin-top: calc(297 / 842 * 8mm);
                }

                .personal-info__name {
                    font-size: 32pt;
                    line-height: 36pt;
                    margin-bottom: calc(297 / 842 * 34mm);

                }

                 .award-description {
                    font-weight: 400;
                    font-size: 16pt;
                    line-height: 24pt;
                }

                .cert-info {
                    position: relative;
                    margin-top: calc(297 / 842 * 16mm);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    flex-grow: 1;
                }

                .cert-info__meta {
                    display: flex;
                    flex-direction: column;
                    justify-content: start;
                    gap: 3.29pt;
                    top: 5pt;
                    right: -220pt;
                    position: absolute;
                    width: 164pt;
                    height: 87pt;
                }

                .cert-info__meta__tag {
                    font-size: 12pt;
                    color: var(--secondary-text-color);
                    box-sizing: border-box;
                    padding: 5pt 10pt;
                    display: flex;
                    height: 27pt;
                    width: max-content;
                    align-items: center;
                    border-radius: 8pt;
                    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.05);;
                }
            </style>
        </head>
        <body>
            <div class="page">
                <div class="page__background">
                    <img alt="" src="${image}" />
                </div>
                <div class="page__content content">
                    <div class="empty-space"></div>
                    <div class="cert-info">
                        <div class="cert-info__meta">
                            <div class="cert-info__meta__tag">${eventDate}</div>
                            <div class="cert-info__meta__tag">${eventDuration}</div>
                            ${eventRegion ? `<div class="cert-info__meta__tag">${eventRegion}</div>` : ''}
                        </div>
                        <div>
                            <div class="content_title">Сертификат</div>
                            <div class="personal-info__school">${schoolNameMessage}</div>
                        </div>
                        <div class="personal-info__name">
                                ${lastName ? `${lastName}` : ''}<br />
                                ${firstName ? `${firstName}` : ''}<br />
                                ${middleName ? `${middleName}` : ''}
                        </div>
                        <div class="award-description">${eventDescription}</div>
                    </div>
                </div>
            </div>
        </body>
    </html>
    `;
};
